import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "simplebar/src/simplebar.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

// third-party
import { Provider as ReduxProvider } from "react-redux";

// apex-chart

// project import
import App from "./App";
import { store } from "@/store";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "@/i18n";

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  // <StrictMode>
  <ReduxProvider store={store}>
    <ToastContainer />
    <App />
  </ReduxProvider>
  // </StrictMode>
);
reportWebVitals();
